// extracted by mini-css-extract-plugin
export default {"newsWrapper":"styles_newsWrapper__VcHHU","titleWrapper":"styles_titleWrapper__A-Hbf","imageContainer":"styles_imageContainer__yfqGD","content":"styles_content__J+3Si"};